import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useLocation } from 'react-router-dom'
import hearts from '../Assets/CONFETTI.png'
import './PhotoAlbumRedirect.css'

export const PHOTO_ALBUM_ANDROID_STORE_LINK =
  process.env.REACT_APP_PHOTO_ALBUM_ANDROID_STORE_LINK ||
  'https://play.google.com/store/apps/details?id=com.firstdance.photoalbum'

export const PHOTO_ALBUM_IOS_STORE_LINK =
  process.env.REACT_APP_PHOTO_ALBUM_IOS_STORE_LINK ||
  'https://apps.apple.com/us/app/first-dance-photo-album/id6808676126'

export const PHOTO_ALBUM_FALLBACK_PATH = '/photo-album'

export function getPhotoAlbumStoreTarget(userAgent = '', platform = '', maxTouchPoints = 0) {
  const isAndroid = /android/i.test(userAgent)
  const isIOS =
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === 'MacIntel' && maxTouchPoints > 1)

  if (isAndroid) return { platform: 'android', href: PHOTO_ALBUM_ANDROID_STORE_LINK }
  if (isIOS) return { platform: 'ios', href: PHOTO_ALBUM_IOS_STORE_LINK }
  return { platform: 'other', href: PHOTO_ALBUM_FALLBACK_PATH }
}

export default function PhotoAlbumRedirect() {
  const location = useLocation()

  useEffect(() => {
    if (typeof window === 'undefined') return

    const userAgent = navigator.userAgent || 'Unknown'
    const tuuid = uuidv4()

    if (location.search.length > 1) {
      fetch(`${process.env.REACT_APP_API}/system/register-system-usage-stat`, {
        method: 'POST',
        body: JSON.stringify({ statName: 'PhotoAlbumAppRedirectPageHit' }),
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
      })

      const urlParams = new URLSearchParams(location.search)
      const fbclid = urlParams.get('fbclid')
      const fbc = fbclid ? `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}` : null
      const fbp = tuuid
      const utmParams = {
        utm_source: urlParams.get('utm_source'),
        utm_id: urlParams.get('utm_id'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_content: urlParams.get('utm_content'),
        utm_term: urlParams.get('utm_term'),
      }

      fetch(`${process.env.REACT_APP_API}/users/log-browser-tracking-info`, {
        method: 'POST',
        body: JSON.stringify({
          eventData: { eventName: 'Redirect', pixelData: { fbp, fbc } },
          customData: { eventSubCategory: 'PhotoAlbumAppStoresRedirectPage', utmParams },
          trackingData: {
            trackingUuid: tuuid,
            deviceSpec: userAgent,
            fbp,
            fbc,
            fbclid,
            utmParams,
            arrivalUrl: '/photo-album/redirect',
          },
        }),
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
      })
    }

    const target = getPhotoAlbumStoreTarget(
      userAgent,
      navigator.platform,
      navigator.maxTouchPoints || 0
    )

    let didHide = false
    const onVisibilityChange = () => {
      if (document.hidden) didHide = true
    }
    document.addEventListener('visibilitychange', onVisibilityChange)

    const goTimer = window.setTimeout(() => {
      window.location.assign(target.href)
    }, 1100)

    const fallbackTimer = window.setTimeout(() => {
      if (!didHide && target.platform !== 'other') {
        window.location.assign(PHOTO_ALBUM_FALLBACK_PATH)
      }
    }, 2800)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
      window.clearTimeout(goTimer)
      window.clearTimeout(fallbackTimer)
    }
  }, [location.search])

  return (
    <div className="photo-album-redirect">
      <img className="photo-album-redirect-confetti" src={hearts} alt="" />
      <div className="photo-album-redirect-card">
        <div className="photo-album-redirect-spinner" aria-hidden="true" />
        <p className="photo-album-redirect-kicker">First Dance</p>
        <h1 className="photo-album-redirect-title">Photo Album</h1>
        <p className="photo-album-redirect-copy">Finding the right store for your device…</p>
      </div>
    </div>
  )
}
